module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }